/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCustomerAccountByUUIDAsync } from '../custom-actions/DataActionExtension.g';
import { Customer } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCustomerAccount Input Action
 */
export class GetCustomerAccountInput implements Msdyn365.IActionInput {
    public identificationNumber: string;

    constructor(identificationNumber: string) {
        this.identificationNumber = identificationNumber;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETCUSTOMERACCOUNT}`;
    public getCacheObjectType = () => 'GETCUSTOMERACCOUNT';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

async function getCustomerAccountAction(input: GetCustomerAccountInput, ctx: Msdyn365.IActionContext): Promise<Customer | undefined> {
    try {
        const result = await getCustomerAccountByUUIDAsync({ callerContext: ctx }, input.identificationNumber);
        return result;
    } catch (error) {
        console.error('Error getting customer account information:', error);
        return undefined;
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Customer | undefined>>getCustomerAccountAction,
    id: 'GetCustomerAccount'
});
